import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  linkButton: {
    textTransform: 'capitalize',
    justifyContent: 'left',
  },
}))
